import React from 'react';
import { Card, Typography } from 'antd';
import { FileGallery } from '../file/FileGallery';

const { Title } = Typography;

interface ScheduleMediaGalleryProps {
  scheduleId: string;
  editable?: boolean;
}

/**
 * スケジュールメディアギャラリーコンポーネント
 * スケジュールに紐づく画像・動画の表示とアップロード機能を提供
 */
export const ScheduleMediaGallery: React.FC<ScheduleMediaGalleryProps> = ({
  scheduleId,
  editable = false,
}) => {
  return (
    <Card
      title={
        <Title level={4} style={{ margin: 0 }}>
          作業記録・写真
        </Title>
      }
      style={{ marginTop: 24 }}
    >
      <FileGallery
        entityType="schedule"
        entityId={scheduleId}
        category="work_record"
        editable={editable}
        maxFiles={30}
        maxSize={10}
        accept="image/*,video/*"
        enableCamera={true}
      />
    </Card>
  );
};
